import React, { useState, useEffect, useRef } from "react";
import TableInputs from "../../components/tableinputs/TableInputs";
import RefreshIcon from "@mui/icons-material/Refresh";
import Style from "../lets_talk/LetsTalk.module.css";
import Buttons from "../../components/buttons/Buttons";
import ModalComponent from "../../components/modalcomponent/ModalComponent";
import Styles from "./Apply_Join_Our_Team.module.css";
import { Form } from "react-bootstrap";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { AxiosInstance } from "../../axios";
import { Arrow_left } from "../../controller/Images";
import ToastMessage from "../../components/messagetoast/ToastMessage";

// File size limits
const MAX_CV_SIZE_MB = 2;
const MAX_CV_SIZE_BYTES = MAX_CV_SIZE_MB * 1024 * 1024;

const MAX_COVERLETTER_SIZE_MB = 2;
const MAX_COVERLETTER_SIZE_BYTES = MAX_COVERLETTER_SIZE_MB * 1024 * 1024;

// Allowed file types
const ALLOWED_CV_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

const ALLOWED_COVERLETTER_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

const generateCaptcha = () => {
  const chars =
    "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
  let captcha = "";
  for (let i = 0; i < 6; i++) {
    captcha += chars[Math.floor(Math.random() * chars.length)];
  }
  return captcha;
};

function Apply_Join_Our_Team() {
  const initialFormData = {
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    countryCode: "",
    message: "",
    captcha: "",
    relocate: "no",
    country: "",
    state: "",
    city: "",
    expected_salary: "",
    uploadcv: null,
    coverletter: null,
    jobId: "",
    role: "",
    experience_year: "",
    experience_month: 0,
  };

  const [formData, setFormData] = useState(initialFormData);
  const [captchaText, setCaptchaText] = useState(generateCaptcha());
  const [errors, setErrors] = useState({});
  const [open, setOpen] = useState(false);
  const { state } = useLocation();
  const [toast, setToast] = useState({
    show: false,
    message: "",
    variant: "",
  });

  const [uploadedFilePaths, setUploadedFilePaths] = useState({
    uploadcvServerPath: "",
    uploadcvOriginalFilename: "",
    coverletterServerPath: "",
    coverletterOriginalFilename: "",
  });

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [phoneCodes, setPhoneCodes] = useState([]);

  const navigate = useNavigate();

  const uploadCvRef = useRef(null);
  const coverLetterRef = useRef(null);
  const years =
    formData.experience_year !== "" ? formData.experience_year : "0";
  const months =
    formData.experience_month !== "" ? formData.experience_month : "0";
  const yearOfExperienceString = `${years}Y - ${months}M`;

  useEffect(() => {
    if (state) {
      setFormData((prev) => ({
        ...prev,
        jobId: state.jobId || "",
        role: state.role || "",
      }));
    }
  }, [state]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const phoneCodeRes = await AxiosInstance.get(
          "/api/joinourteam/listphonecode",
        );
        if (
          phoneCodeRes.data.status &&
          Array.isArray(phoneCodeRes.data.phonecode)
        ) {
          const fetchedPhoneCodes = phoneCodeRes.data.phonecode.map(
            (codeObj, index) => ({
              label: `+${codeObj.phonecode}`,
              value: `${codeObj.phonecode}`,
              key: `phonecode-${codeObj.phonecode}-${index}`,
            }),
          );
          setPhoneCodes(fetchedPhoneCodes);

          if (fetchedPhoneCodes.length > 0) {
            const defaultPhoneCode =
              fetchedPhoneCodes.find((pc) => pc.value === "91") ||
              fetchedPhoneCodes[0];
            setFormData((prev) => ({
              ...prev,
              countryCode: defaultPhoneCode.value,
            }));
          } else {
            setFormData((prev) => ({
              ...prev,
              countryCode: "",
            }));
          }
        } else {
          setPhoneCodes([]);
        }
      } catch (err) {
        console.error("Error fetching phone codes:", err);
        setErrors((prev) => ({
          ...prev,
          phoneCode: "Failed to load phone codes.",
        }));
        setPhoneCodes([]);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchCountries = async () => {
      if (formData.countryCode) {
        try {
          const res = await AxiosInstance.post("/api/joinourteam/listcountries", {
            phonecode: parseInt(formData.countryCode, 10),
          });
          if (res.data.status && Array.isArray(res.data.countries)) {
            const countriesData = res.data.countries.map((c) => ({
              label: c.name,
              value: c.id,
              key: c.id,
            }));
            setCountries(countriesData);
            if (
              !countriesData.some((c) => c.value === formData.country) &&
              formData.country !== ""
            ) {
              setFormData((prev) => ({
                ...prev,
                country: "",
                state: "",
                city: "",
              }));
            } else if (
              countriesData.length > 0 &&
              formData.country === "" &&
              countriesData.some((c) => c.label === "India")
            ) {
              setFormData((prev) => ({
                ...prev,
                country: countriesData.find((c) => c.label === "India")?.value,
              }));
            } else if (countriesData.length > 0 && formData.country === "") {
              setFormData((prev) => ({
                ...prev,
                country: countriesData[0]?.value,
              }));
            }
          } else {
            setCountries([]);
            setFormData((prev) => ({
              ...prev,
              country: "",
              state: "",
              city: "",
            }));
          }
        } catch (err) {
          console.error(
            "Error fetching countries:",
            err.response?.data || err.message,
          );
          setErrors((prev) => ({
            ...prev,
            country: "Failed to load countries.",
          }));
          setCountries([]);
          setFormData((prev) => ({
            ...prev,
            country: "",
            state: "",
            city: "",
          }));
        }
      } else {
        setCountries([]);
        setStates([]);
        setCities([]);
        setFormData((prev) => ({
          ...prev,
          country: "",
          state: "",
          city: "",
        }));
      }
    };
    fetchCountries();
  }, [formData.countryCode]);

  useEffect(() => {
    const fetchStates = async () => {
      if (formData.country) {
        try {
          const res = await AxiosInstance.post("/api/joinourteam/liststates", {
            country_id: formData.country,
          });

          if (res.data.status && Array.isArray(res.data.states)) {
            const statesData = res.data.states.map((s) => ({
              label: s.name,
              value: s.id,
              key: s.id,
            }));
            setStates(statesData);
            if (
              !statesData.some((s) => s.value === formData.state) &&
              formData.state !== ""
            ) {
              setFormData((prev) => ({
                ...prev,
                state: "",
                city: "",
              }));
            }
          } else {
            setStates([]);
            setFormData((prev) => ({
              ...prev,
              state: "",
              city: "",
            }));
          }
        } catch (err) {
          console.error(
            "Error fetching states:",
            err.response?.data || err.message,
          );
          setErrors((prev) => ({ ...prev, state: "Failed to load states." }));
          setStates([]);
          setFormData((prev) => ({
            ...prev,
            state: "",
            city: "",
          }));
        }
      } else {
        setStates([]);
        setCities([]);
        setFormData((prev) => ({
          ...prev,
          state: "",
          city: "",
        }));
      }
    };
    fetchStates();
  }, [formData.country]);

  useEffect(() => {
    const fetchCities = async () => {
      if (formData.state) {
        try {
          const res = await AxiosInstance.post("/api/joinourteam/listcities", {
            state_id: formData.state,
          });
          if (res.data.status && Array.isArray(res.data.cities)) {
            const citiesData = res.data.cities.map((c, index) => ({
              label: c.name,
              value: c.name,
              id: c.id,
              key: `${c.name}-${c.id || index}`,
            }));
            setCities(citiesData);
            if (
              !citiesData.some((c) => c.value === formData.city) &&
              formData.city !== ""
            ) {
              setFormData((prev) => ({
                ...prev,
                city: "",
              }));
            }
          } else {
            setCities([]);
            setFormData((prev) => ({
              ...prev,
              city: "",
            }));
          }
        } catch (err) {
          console.error(
            "Error fetching cities:",
            err.response?.data || err.message,
          );
          setErrors((prev) => ({ ...prev, city: "Failed to load cities." }));
          setCities([]);
          setFormData((prev) => ({
            ...prev,
            city: "",
          }));
        }
      } else {
        setCities([]);
        setFormData((prev) => ({
          ...prev,
          city: "",
        }));
      }
    };
    fetchCities();
  }, [formData.state]);

  // File validation function
  const validateFile = (file, fileType) => {
    if (!file) {
      return fileType === "uploadcv" ? "Upload CV is required." : "";
    }

    const allowedTypes =
      fileType === "uploadcv" ? ALLOWED_CV_TYPES : ALLOWED_COVERLETTER_TYPES;
    const maxSize =
      fileType === "uploadcv" ? MAX_CV_SIZE_BYTES : MAX_COVERLETTER_SIZE_BYTES;
    const maxSizeMB =
      fileType === "uploadcv" ? MAX_CV_SIZE_MB : MAX_COVERLETTER_SIZE_MB;

    // Check file type
    if (!allowedTypes.includes(file.type)) {
      const allowedExtensions = allowedTypes
        .map((type) => {
          if (type === "application/pdf") return "PDF";
          if (type === "application/msword") return "DOC";
          if (
            type ===
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          )
            return "DOCX";
          return type;
        })
        .join(", ");

      return `Invalid file type. Only ${allowedExtensions} are allowed.`;
    }

    // Check file size
    if (file.size > maxSize) {
      return `File size exceeds ${maxSizeMB}MB. Please choose a smaller file.`;
    }

    return "";
  };

  const uploadFile = async (file, fileType) => {
    // Validate file before upload
    const validationError = validateFile(file, fileType);
    if (validationError) {
      setErrors((prev) => ({
        ...prev,
        [fileType]: validationError,
      }));
      return null;
    }

    const uploadFormData = new FormData();
    let backendFieldName;
    let responsePathKey;

    if (fileType === "uploadcv") {
      backendFieldName = "upload_cv";
      responsePathKey = "upload_cv";
    } else if (fileType === "coverletter") {
      backendFieldName = "upload_coverletter";
      responsePathKey = "upload_coverletter";
    } else {
      console.error("Invalid file type for upload:", fileType);
      return null;
    }

    uploadFormData.append(backendFieldName, file);

    try {
      const response = await AxiosInstance.post(
        "/api/joinourteam/upload",
        uploadFormData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response.data.status && response.data.file) {
        const serverFilePath = response.data.file[responsePathKey];
        setUploadedFilePaths((prev) => ({
          ...prev,
          [fileType + "ServerPath"]: serverFilePath,
        }));
        setErrors((prev) => ({
          ...prev,
          [fileType]: "",
        }));
        return serverFilePath;
      } else {
        throw new Error(
          response.data.message ||
            "File upload failed or file path not returned.",
        );
      }
    } catch (error) {
      console.error(`Error uploading ${fileType}:`, error);
      setErrors((prev) => ({
        ...prev,
        [fileType]: `Failed to upload ${fileType}. Please try again.`,
      }));
      setUploadedFilePaths((prev) => ({
        ...prev,
        [fileType + "ServerPath"]: "",
      }));
      return null;
    }
  };

  const validateField = (name, value, currentFormData) => {
    switch (name) {
      case "first_name": {
        const trimmedValue = value?.trim();

        if (!trimmedValue) {
          return "First Name is required.";
        }

        if (trimmedValue.length < 3) {
          return "First Name must be at least 3 characters.";
        }

        // Emoji check
        const emojiRegex = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/u;
        if (emojiRegex.test(trimmedValue)) {
          return "First Name should not contain emojis.";
        }

        // Numbers check
        const numberRegex = /\d/;
        if (numberRegex.test(trimmedValue)) {
          return "First Name should not contain numbers.";
        }

        // Special characters check
        const specialCharRegex = /[!@#$%^&*()_+}{":?><]/;
        if (specialCharRegex.test(trimmedValue)) {
          return "First Name should not contain special characters.";
        }

        return "";
      }

      case "last_name": {
        const trimmedValue = value?.trim();

        if (!trimmedValue) {
          return "Last Name is required.";
        }

        if (trimmedValue.length < 1) {
          return "Last Name must be at least 1 character.";
        }

        // Emoji check
        const emojiRegex = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/u;
        if (emojiRegex.test(trimmedValue)) {
          return "Last Name should not contain emojis.";
        }

        // Numbers check
        const numberRegex = /\d/;
        if (numberRegex.test(trimmedValue)) {
          return "Last Name should not contain numbers.";
        }

        // Special characters check
        const specialCharRegex = /[!@#$%^&*()_+}{":?><]/;
        if (specialCharRegex.test(trimmedValue)) {
          return "Last Name should not contain special characters.";
        }

        return "";
      }

      case "email":
        return /^\S+@\S+\.\S+$/.test(value) ? "" : "Invalid email address.";
      case "expected_salary":
        return value && !/^\d+$/.test(value)
          ? "Expected salary must be a valid number (digits only)."
          : "";
      case "phone":
        return value
          ? /^\d{10}$/.test(value)
            ? ""
            : "Phone must be 10 digits."
          : "Phone is required.";
      case "message":
        return value ? "" : "Message is required.";
      case "captcha":
        return value ? "" : "Please enter CAPTCHA.";
      case "experience_year":
      case "experience_month":
        return currentFormData.experience_year === "" &&
          currentFormData.experience_month === ""
          ? "Years or months of experience required."
          : "";
      case "country":
        return currentFormData.countryCode &&
          countries.length > 0 &&
          value === ""
          ? "Country is required."
          : "";
      case "state":
        return currentFormData.country && states.length > 0 && value === ""
          ? "State is required."
          : "";
      case "city":
        return currentFormData.state && cities.length > 0 && value === ""
          ? "City is required."
          : "";
      case "relocate":
        return value ? "" : "Relocation preference is required.";
      case "uploadcv":
        return validateFile(value, "uploadcv");
      case "coverletter":
        return validateFile(value, "coverletter");
      default:
        return "";
    }
  };

  const handleChange = async (e) => {
    const { name, value, type, files } = e.target;
    let newValue;

    if (type === "file") {
      newValue = files[0];

      // Clear previous errors for this field when value changes
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));

      // Set form data immediately for UI feedback
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: newValue,
      }));

      if (newValue) {
        // Set the original filename immediately
        if (name === "uploadcv") {
          setUploadedFilePaths((prev) => ({
            ...prev,
            uploadcvOriginalFilename: newValue.name,
          }));
        } else if (name === "coverletter") {
          setUploadedFilePaths((prev) => ({
            ...prev,
            coverletterOriginalFilename: newValue.name,
          }));
        }

        // Upload file and validate
        await uploadFile(newValue, name);
      } else {
        // Clear file paths if no file selected
        if (name === "uploadcv") {
          setUploadedFilePaths((prev) => ({
            ...prev,
            uploadcvOriginalFilename: "",
            uploadcvServerPath: "",
          }));
        } else if (name === "coverletter") {
          setUploadedFilePaths((prev) => ({
            ...prev,
            coverletterOriginalFilename: "",
            coverletterServerPath: "",
          }));
        }
      }
      return;
    }

    newValue = value;

    const updatedFormData = {
      ...formData,
      [name]: newValue,
    };

    // Clear error for the field being changed
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));

    // For dependent fields, also clear their errors
    if (name === "countryCode" && formData.countryCode !== newValue) {
      updatedFormData.country = "";
      updatedFormData.state = "";
      updatedFormData.city = "";
      setErrors((prevErrors) => ({
        ...prevErrors,
        country: "",
        state: "",
        city: "",
      }));
      setCountries([]);
      setStates([]);
      setCities([]);
    } else if (name === "country" && formData.country !== newValue) {
      updatedFormData.state = "";
      updatedFormData.city = "";
      setErrors((prevErrors) => ({
        ...prevErrors,
        state: "",
        city: "",
      }));
      setStates([]);
      setCities([]);
    } else if (name === "state" && formData.state !== newValue) {
      updatedFormData.city = "";
      setErrors((prevErrors) => ({ ...prevErrors, city: "" }));
      setCities([]);
    } else if (name === "experience_year" || name === "experience_month") {
      setErrors((prevErrors) => ({
        ...prevErrors,
        experience_year: "",
        experience_month: "",
      }));
    }

    setFormData(updatedFormData);
  };

  const resetFormAndCaptcha = () => {
    setFormData({
      ...initialFormData,
      jobId: state?.jobId || "",
      role: state?.role || "",
      countryCode: phoneCodes[0]?.value || "",
    });
    setErrors({});
    setCaptchaText(generateCaptcha());
    setStates([]);
    setCities([]);

    if (uploadCvRef.current) {
      uploadCvRef.current.value = "";
    }
    if (coverLetterRef.current) {
      coverLetterRef.current.value = "";
    }

    setUploadedFilePaths({
      uploadcvServerPath: "",
      uploadcvOriginalFilename: "",
      coverletterServerPath: "",
      coverletterOriginalFilename: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    let formIsValid = true;

    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    const emojiRegex = /\p{Extended_Pictographic}/u;

    // Replace your current first_name validation in handleSubmit
    if (!formData.first_name) {
      newErrors.first_name = "First Name is required.";
      formIsValid = false;
    } else {
      const firstNameError = validateField(
        "first_name",
        formData.first_name,
        formData,
      );
      if (firstNameError) {
        newErrors.first_name = firstNameError;
        formIsValid = false;
      }
    }

    if (!formData.last_name) {
      newErrors.last_name = "Last Name is required.";
      formIsValid = false;
    } else {
      const lastNameError = validateField(
        "last_name",
        formData.last_name,
        formData,
      );
      if (lastNameError) {
        newErrors.last_name = lastNameError;
        formIsValid = false;
      }
    }

    if (!formData.email) {
      newErrors.email = "Email is required";
      formIsValid = false;
    } else if (emojiRegex.test(formData.email)) {
      newErrors.email = "Email cannot contain emojis";
      formIsValid = false;
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Invalid email address";
      formIsValid = false;
    }

    // if (!formData.phone) {
    //   newErrors.phone = "Phone number is required";
    //   formIsValid = false;
    // } else if (!/^\d{7,15}$/.test(formData.phone)) {
    //   newErrors.phone = "Invalid phone number format";
    //   formIsValid = false;
    // }
    if (!formData.phone) {
      newErrors.phone = "Phone number is required";
      formIsValid = false;
    } else {
      const digitsOnly = formData.phone.replace(/\D/g, ""); // safety

      if (formData.countryCode === "91") {
        // India → exactly 10 digits
        if (!/^\d{10}$/.test(digitsOnly)) {
          newErrors.phone = "phone number must be exactly 10 digits";
          formIsValid = false;
        }
      } else {
        // Other countries → 8 to 15 digits
        if (!/^\d{8,15}$/.test(digitsOnly)) {
          newErrors.phone = "Invalid phone number format";
          formIsValid = false;
        }
      }
    }

    if (!formData.message) {
      newErrors.message = "Message is required.";
      formIsValid = false;
    }

    // Country, State, City validation
    if (formData.countryCode && countries.length > 0 && !formData.country) {
      newErrors.country = "Country is required.";
      formIsValid = false;
    }
    if (!formData.city) newErrors.city = "City is required";
    if (formData.country && states.length > 0 && !formData.state) {
      newErrors.state = "State is required.";
      formIsValid = false;
    }

    if (formData.state && cities.length > 0 && !formData.city) {
      newErrors.city = "City is required.";
      formIsValid = false;
    }

    // Relocate validation
    if (!formData.relocate) {
      newErrors.relocate = "Relocation preference is required.";
      formIsValid = false;
    }

    // Experience validation
    if (formData.experience_year === "" && formData.experience_month === "") {
      newErrors.experience_year = "Years or months of experience required.";
      newErrors.experience_month = "Years or months of experience required.";
      formIsValid = false;
    }

    // Expected salary validation
    if (formData.expected_salary && !/^\d+$/.test(formData.expected_salary)) {
      newErrors.expected_salary =
        "Expected salary must be a valid number (digits only).";
      formIsValid = false;
    }

    // CAPTCHA validation
    if (!formData.captcha) {
      newErrors.captcha = "CAPTCHA is required";
      formIsValid = false;
    } else if (formData.captcha.toLowerCase() !== captchaText.toLowerCase()) {
      newErrors.captcha = "Invalid CAPTCHA. Please try again.";
      formIsValid = false;
    }

    // File validations
    if (!uploadedFilePaths.uploadcvServerPath && !formData.uploadcv) {
      newErrors.uploadcv = "Upload CV is required.";
      formIsValid = false;
    }

    // Cover letter file validation if provided
    if (formData.coverletter) {
      const coverLetterError = validateFile(
        formData.coverletter,
        "coverletter",
      );
      if (coverLetterError) {
        newErrors.coverletter = coverLetterError;
        formIsValid = false;
      }
    }

    // CV file validation if provided but not uploaded to server
    if (formData.uploadcv && !uploadedFilePaths.uploadcvServerPath) {
      const cvError = validateFile(formData.uploadcv, "uploadcv");
      if (cvError) {
        newErrors.uploadcv = cvError;
        formIsValid = false;
      }
    }

    // Set errors and stop if invalid
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    }

    if (!formIsValid) {
      const errorFieldNames = Object.keys(newErrors);
      if (errorFieldNames.length > 0) {
        const firstInvalidFieldName = errorFieldNames[0];
        const firstErrorElement = document.querySelector(
          `[name="${firstInvalidFieldName}"], [id="${firstInvalidFieldName}"]`,
        );
        if (firstErrorElement) {
          firstErrorElement.focus();
          firstErrorElement.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        } else {
          const firstErrorSpan = document.querySelector(".custom_error");
          if (firstErrorSpan) {
            firstErrorSpan.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        }
      }

      // setToast({
      //   show: true,
      //   message: "Please correct the errors in the form.",
      //   variant: "danger",
      // });
      return;
    }

    const selectedCountry = countries.find((c) => c.value === formData.country);
    const selectedState = states.find((s) => s.value === formData.state);
    const selectedCity = cities.find((c) => c.value === formData.city);

    let yearOfExperienceString = "";
    if (formData.experience_year !== "") {
      yearOfExperienceString += `${formData.experience_year}Y -`;
    }
    if (formData.experience_month !== "") {
      if (yearOfExperienceString !== "") {
        yearOfExperienceString += " ";
      }
      yearOfExperienceString += `${formData.experience_month}M`;
    }

    const payload = {
      job_id: formData.jobId || "",
      first_name: formData.first_name,
      last_name: formData.last_name,
      email: formData.email,
      phone_number: formData.phone || null,
      country_name: selectedCountry?.label || null,
      country_id: selectedCountry?.value || null,
      state_name: selectedState?.label || null,
      state_id: selectedState?.value || null,
      city_name: selectedCity?.value || null,
      city_id: selectedCity?.id || null,
      is_relocated: formData.relocate === "yes" ? 1 : 0,
      expected_salary: formData.expected_salary
        ? parseInt(formData.expected_salary, 10)
        : null,
      yearof_experience: yearOfExperienceString || null,
      original_cvpath: uploadedFilePaths.uploadcvOriginalFilename || null,
      upload_cv: uploadedFilePaths.uploadcvServerPath || null,
      upload_coverletter: uploadedFilePaths.coverletterServerPath || null,
      original_coverletter_path:
        uploadedFilePaths.coverletterOriginalFilename || null,
      message: formData.message,
      created_by: formData.email,
    };


    try {
      const response = await AxiosInstance.post(
        "/api/joinourteam/candidate/create",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (response.data.status) {
        setOpen(true);
        resetFormAndCaptcha();
        setToast({
          show: true,
          message: "Application submitted successfully!",
          variant: "success",
        });
      } else {
        setOpen(false);
        setToast({
          show: true,
          message:
            response.data.message ||
            "Application submission failed. Please try again.",
          variant: "danger",
        });
      }
    } catch (err) {
      console.error(
        "Application submission error:",
        err.response?.data || err.message || err,
      );
      setOpen(false);
      setToast({
        show: true,
        message:
          err.response?.data?.message ||
          "Failed to submit form. Please try again.",
        variant: "danger",
      });
    }
  };

  const handleModalClose = () => {
    setOpen(false);
    navigate("/join-our-team");
  };

  const handleCancel = () => {
    // resetFormAndCaptcha();
    navigate(-1);
  };

  useEffect(() => {
    if (toast.show) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [toast.show]);

  return (
    <div className="container-fluid pt-3">
      <div className="row">
        <div
          className={`main_heading d-flex align-items-center ${Style.main_div}`}
        >
          <div className={`px-5 ${Styles.headingRow} m-0`}>
            <img
              src={Arrow_left}
              alt="Back"
              onClick={() =>
                navigate(`/join-our-team-view/${formData.jobId}`, {
                  state: { jobId: formData.jobId, role: formData.role },
                })
              }
              title="Go Back"
            />

            <h5 className="main_heading">{formData.role}</h5>
          </div>
        </div>

        <ModalComponent
          show={open}
          onHide={handleModalClose}
          title="Application Submitted"
          bodyText="Thank you for applying! Our team will review your application and get back to you soon."
          buttontext="OK"
        />

        <form onSubmit={handleSubmit}>
          <div className={`py-3 ${Styles.responsivepadding}`}>
            <div className={`card p-4  ${Style.Custom_Card}`}>
              <div className={`row ${Style.form_label}`}>
                <div className="row">
                  <div className="col-md-6 mb-2">
                    <TableInputs
                      label="First Name"
                      name="first_name"
                      id="first_name"
                      placeholder="Enter your first name"
                      value={formData.first_name}
                      onChange={handleChange}
                    />
                    {errors.first_name && (
                      <span className="custom_error">{errors.first_name}</span>
                    )}
                  </div>
                  <div className="col-md-6 mb-2">
                    <TableInputs
                      label="Last Name"
                      name="last_name"
                      id="last_name"
                      placeholder="Enter your last name"
                      value={formData.last_name}
                      onChange={handleChange}
                    />
                    {errors.last_name && (
                      <span className="custom_error">{errors.last_name}</span>
                    )}
                  </div>
                </div>
                <div className="row">
                  {/* <div className="col-md-6 mb-2">
                    <TableInputs
                      label="Email Address"
                      type="email"
                      name="email"
                      id="email"
                      placeholder="Enter your email address"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && (
                      <span className="custom_error">{errors.email}</span>
                    )}
                  </div> */}
                  <div className="col-md-6 mb-2">
                    <TableInputs
                      label="Email Address"
                      type="text"
                      name="email"
                      id="email"
                      placeholder="Enter your email address"
                      value={formData.email}
                      onChange={(e) => {
                        const emojiRegex =
                          /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu;
                        const cleanValue = e.target.value.replace(
                          emojiRegex,
                          "",
                        ); // remove emojis
                        handleChange({
                          target: { name: "email", value: cleanValue },
                        });
                      }}
                    />
                    {errors.email && (
                      <span className="custom_error">{errors.email}</span>
                    )}
                  </div>

                  <div className="col-md-6 mb-2">
                    <Form.Label className="form-label">Phone Number</Form.Label>
                    <div className="d-flex gap-2">
                      <div style={{ maxWidth: "120px", flex: "0 0 auto" }}>
                        <TableInputs
                          name="countryCode"
                          id="countryCode"
                          type="select"
                          value={formData.countryCode}
                          onChange={handleChange}
                          options={phoneCodes}
                          placeholder="+91"
                          disabled
                        />
                      </div>
                      <div className="flex-grow-1">
                        <TableInputs
                          name="phone"
                          id="phone"
                          type="Number"
                          value={formData.phone}
                          onChange={handleChange}
                          placeholder="Enter your phone number"
                        />
                      </div>
                    </div>
                    {errors.phone && (
                      <span className="custom_error">{errors.phone}</span>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 mb-2">
                    <TableInputs
                      label="Country"
                      name="country"
                      id="country"
                      type="select"
                      value={formData.country}
                      onChange={handleChange}
                      options={countries}
                      placeholder="Please select your Country"
                      // disabled={!formData.countryCode || countries.length === 0}
                      disabled
                    />
                    {errors.country && (
                      <span className="custom_error">{errors.country}</span>
                    )}
                  </div>
                  <div className="col-md-6 mb-2">
                    <TableInputs
                      label="State"
                      name="state"
                      id="state"
                      type="select"
                      value={formData.state}
                      onChange={handleChange}
                      options={states}
                      placeholder="Please select your State"
                      disabled={!formData.country || states.length === 0}
                    />
                    {errors.state && (
                      <span className="custom_error">{errors.state}</span>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 mb-2">
                    <TableInputs
                      label="City"
                      name="city"
                      id="city"
                      type="select"
                      value={formData.city}
                      onChange={handleChange}
                      options={cities}
                      placeholder="Please select your City"
                      disabled={!formData.state || cities.length === 0}
                    />
                    {errors.city && (
                      <span className="custom_error">{errors.city}</span>
                    )}
                  </div>
                  <div className="col-md-6 mb-2 d-flex flex-column justify-content-center align-items-start">
                    <label className="form-label mb-2" htmlFor="relocateYes">
                      Are you willing to relocate?
                    </label>
                    <div className="d-flex gap-3">
                      <Form.Check
                        className={`custom-radio ${Styles.label_text}`}
                        type="radio"
                        label={<span style={{ color: "#142454" }}>Yes</span>}
                        name="relocate"
                        id="relocateYes"
                        value="yes"
                        checked={formData.relocate === "yes"}
                        onChange={handleChange}
                      />
                      <Form.Check
                        className={`custom-radio ${Styles.label_text}`}
                        type="radio"
                        label={<span style={{ color: "#142454" }}>No</span>}
                        name="relocate"
                        id="relocateNo"
                        value="no"
                        checked={formData.relocate === "no"}
                        onChange={handleChange}
                      />
                    </div>
                    {errors.relocate && (
                      <span className="custom_error mt-1">
                        {errors.relocate}
                      </span>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 mb-2">
                    <TableInputs
                      label="Expected salary (INR) Optional"
                      type="Number"
                      name="expected_salary"
                      id="expected_salary"
                      placeholder="Enter expected salary"
                      value={formData.expected_salary}
                      onChange={handleChange}
                      onKeyDown={(e) => {
                        if (
                          !/[0-9]/.test(e.key) &&
                          ![
                            "Backspace",
                            "Delete",
                            "ArrowLeft",
                            "ArrowRight",
                            "Tab",
                          ].includes(e.key) &&
                          !(e.ctrlKey || e.metaKey)
                        ) {
                          e.preventDefault();
                        }
                      }}
                    />
                    {errors.expected_salary && (
                      <span className="custom_error">
                        {errors.expected_salary}
                      </span>
                    )}
                  </div>
                  <div className="col-md-6 mb-2">
                    <label className="form-label">Total Experience</label>
                    <div className="row">
                      <div className="col-6">
                        <TableInputs
                          name="experience_year"
                          id="experience_year"
                          type="select"
                          value={formData.experience_year}
                          onChange={handleChange}
                          options={[
                            { label: "0 Year", value: "0" },
                            { label: "1 Year", value: "1" },
                            { label: "2 Years", value: "2" },
                            { label: "3 Years", value: "3" },
                            { label: "4 Years", value: "4" },
                            { label: "5 Years", value: "5" },
                            { label: "6 Years", value: "6" },
                            { label: "7 Years", value: "7" },
                            { label: "8 Years", value: "8" },
                            { label: "9 Years", value: "9" },
                            { label: "10 Years", value: "10" },
                            { label: "11 Years", value: "11" },
                          ]}
                          placeholder="Select Years"
                        />
                      </div>
                      <div className="col-6">
                        <TableInputs
                          name="experience_month"
                          id="experience_month"
                          type="select"
                          value={formData.experience_month}
                          onChange={handleChange}
                          options={[
                            { label: "0 Month", value: "0" },
                            { label: "1 Month", value: "1" },
                            { label: "2 Months", value: "2" },
                            { label: "3 Months", value: "3" },
                            { label: "4 Months", value: "4" },
                            { label: "5 Months", value: "5" },
                            { label: "6 Months", value: "6" },
                            { label: "7 Months", value: "7" },
                            { label: "8 Months", value: "8" },
                            { label: "9 Months", value: "9" },
                            { label: "10 Months", value: "10" },
                            { label: "11 Months", value: "11" },
                          ]}
                          placeholder="Select Months"
                        />
                      </div>
                    </div>
                    {(errors.experience_year || errors.experience_month) && (
                      <span className="custom_error">
                        {errors.experience_year || errors.experience_month}
                      </span>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 mb-2">
                    <TableInputs
                      label="Upload CV (PDF/DOC/DOCX, Max 2MB)"
                      type="file"
                      name="uploadcv"
                      id="uploadcv"
                      onChange={handleChange}
                      accept=".doc,.docx,.pdf"
                      ref={uploadCvRef}
                    />
                    {errors.uploadcv && (
                      <span className="custom_error">{errors.uploadcv}</span>
                    )}
                  </div>
                  <div className="col-md-6 mb-2">
                    <TableInputs
                      label="Upload Cover Letter (PDF/DOC/DOCX, Max 2MB) (optional)"
                      type="file"
                      name="coverletter"
                      id="coverletter"
                      onChange={handleChange}
                      accept=".doc,.docx,.pdf"
                      ref={coverLetterRef}
                    />
                    {errors.coverletter && (
                      <span className="custom_error">{errors.coverletter}</span>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 mb-2">
                    <TableInputs
                      label="Message"
                      name="message"
                      id="message"
                      type="textarea"
                      placeholder="Briefly tell us about yourself and why you're a good fit..."
                      value={formData.message}
                      onChange={handleChange}
                      row="3"
                      showWordCount={true}
                    />
                    {errors.message && (
                      <span className="custom_error">{errors.message}</span>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 mb-2">
                    <label className="form-label">Verification Code</label>
                    <div className="custom-captcha-wrapper d-flex align-items-center gap-2">
                      <input
                        type="text"
                        name="captcha"
                        id="captcha"
                        className="form-control w-50"
                        placeholder="Enter the CAPTCHA code"
                        value={formData.captcha}
                        onChange={handleChange}
                      />
                      <span className="captcha-text">{captchaText}</span>
                      <span
                        className="refresh-icon"
                        onClick={() => setCaptchaText(generateCaptcha())}
                      >
                        <RefreshIcon
                          style={{ color: "#FA840E", cursor: "pointer" }}
                        />
                      </span>
                    </div>
                    {errors.captcha && (
                      <span className="custom_error">{errors.captcha}</span>
                    )}
                  </div>
                </div>
                <div className="row mt-5 justify-content-center g-3">
                  <div className="col-12 col-md-auto d-flex justify-content-center">
                    <Buttons
                      type="button"
                      text="Cancel"
                      onClick={handleCancel}
                      variant="secondary"
                    />
                  </div>

                  <div className="col-12 col-md-auto d-flex justify-content-center">
                    <Buttons type="submit" text="Submit" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <ToastMessage
        show={toast.show}
        onClose={() => setToast({ ...toast, show: false })}
        message={toast.message}
        variant={toast.variant}
      />
    </div>
  );
}

export default Apply_Join_Our_Team;
